import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEqual, isEmpty } from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
import { SettingsMobileHeader, SettingsPanelHeader, FocusManager, Tabs, Tab, SettingsPanelFooter, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { mergeStyles, WEB_ADDRESS_CATEGORY, isNewTab, ADD_PLUGIN_LINK_BI } from 'wix-rich-content-common';
import DesignComponent from '../components/design-component.js';
import SettingsComponent from '../components/settings-component.js';
import PreviewComponent from '../components/preview-component.js';
import { settingsTabValue, designTabValue } from '../constants.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { LINK_BUTTON_TYPE } from '../types.js';
import classNames from 'classnames';
import 'wix-rich-content-plugin-commons';
import '../components/color-toggle-component.js';
import '../defaults.js';
import '../button-component.js';
import '../classNameStrategies.js';
import '../default-styles-74c82233.js';
import '../components/button-viewer.js';
import '../viewer/button-viewer.js';
import 'ricos-context';
import 'ricos-schema';

var css_248z = "[dir=ltr] ._-9vKF{text-align:left}[dir=rtl] ._-9vKF{text-align:right}@media only screen and (max-width:640px){[dir] [data-query=media] ._-9vKF{padding:33px 20px 10px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] ._-9vKF{padding:33px 20px 10px}}}@container (width < 640px){[dir] [data-query=container] ._-9vKF{padding:33px 20px 10px}}@media only screen and (max-width:640px){[data-query=media] ._-9vKF.IOfME{height:calc(100% - 100px)}[dir] [data-query=media] ._-9vKF.IOfME{padding:0}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._-9vKF.IOfME{height:calc(100% - 100px)}[dir] [data-query=container] ._-9vKF.IOfME{padding:0}}}@container (width < 640px){[data-query=container] ._-9vKF.IOfME{height:calc(100% - 100px)}[dir] [data-query=container] ._-9vKF.IOfME{padding:0}}[dir] .XJIkY{margin-top:100px}@media only screen and (max-width:640px){[dir] [data-query=media] .YPc9L{padding-bottom:0;padding-top:24px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .YPc9L{padding-bottom:0;padding-top:24px}}}@container (width < 640px){[dir] [data-query=container] .YPc9L{padding-bottom:0;padding-top:24px}}[dir] .TQyGq{border-top:none}[dir] .a815v{border-top:1px solid #ccc}._9I9aQ{height:calc(100vh - 152px);overflow-y:scroll}@media only screen and (max-width:640px){[data-query=media] ._9I9aQ{height:calc(100vh - 155px);overflow-x:hidden}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._9I9aQ{height:calc(100vh - 155px);overflow-x:hidden}}}@container (width < 640px){[data-query=container] ._9I9aQ{height:calc(100vh - 155px);overflow-x:hidden}}.eN1Ab{align-items:center;box-sizing:border-box;display:flex;height:auto}[dir] .eN1Ab{margin-top:1px;padding:18px 30px 21px}.GEgGZ{color:var(--ricos-settings-text-color,#333);font-size:20px;width:100%}[dir] .GEgGZ{margin-bottom:10px;margin-top:13px}@media only screen and (max-width:640px){[data-query=media] .GEgGZ{color:var(--ricos-settings-text-color,#000);font-size:20px;line-height:1.4}[dir] [data-query=media] .GEgGZ{margin-top:0}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .GEgGZ{color:var(--ricos-settings-text-color,#000);font-size:20px;line-height:1.4}[dir] [data-query=container] .GEgGZ{margin-top:0}}}@container (width < 640px){[data-query=container] .GEgGZ{color:var(--ricos-settings-text-color,#000);font-size:20px;line-height:1.4}[dir] [data-query=container] .GEgGZ{margin-top:0}}.P9GAX{font-size:16px;width:100%}[dir] .P9GAX{margin:10px 0}@media only screen and (max-width:640px){[data-query=media] .P9GAX{font-size:16px}[dir] [data-query=media] .P9GAX{margin:9px 0 0;padding-bottom:8px}[dir=ltr] [data-query=media] .P9GAX{padding-left:20px}[dir=rtl] [data-query=media] .P9GAX{padding-right:20px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .P9GAX{font-size:16px}[dir] [data-query=container] .P9GAX{margin:9px 0 0;padding-bottom:8px}[dir=ltr] [data-query=container] .P9GAX{padding-left:20px}[dir=rtl] [data-query=container] .P9GAX{padding-right:20px}}}@container (width < 640px){[data-query=container] .P9GAX{font-size:16px}[dir] [data-query=container] .P9GAX{margin:9px 0 0;padding-bottom:8px}[dir=ltr] [data-query=container] .P9GAX{padding-left:20px}[dir=rtl] [data-query=container] .P9GAX{padding-right:20px}}[dir=ltr] .pTsC5{margin-right:12px}[dir=rtl] .pTsC5{margin-left:12px}.N5LCr{color:red}.zBKRb{color:#f97972;position:absolute;top:2px}[dir=ltr] .zBKRb{left:150px}[dir=rtl] .zBKRb{right:150px}[dir=ltr] .am-QZ+.am-QZ{border-left:0}[dir=rtl] .am-QZ+.am-QZ{border-right:0}.XNVN5{height:634px;overflow-y:scroll}.JfTde{display:block}[dir] .JfTde{margin-top:15px}.yT6j2{opacity:.3;width:4px}[dir] .yT6j2{background:#000;border-radius:4px;cursor:pointer}.wiJHZ:hover{opacity:.8}._4-F-t{height:100%}.tEwkQ{box-sizing:border-box;height:calc(100vh - 242px);overflow:hidden}[dir] .tEwkQ{padding:22px 30px 0}@media only screen and (max-width:640px){[dir] [data-query=media] .tEwkQ{padding:20px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .tEwkQ{padding:20px}}}@container (width < 640px){[dir] [data-query=container] .tEwkQ{padding:20px}}.IOfME .tEwkQ{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .IOfME .tEwkQ{padding:24px}.IOfME .tEwkQ *,.IOfME .tEwkQ :after,.IOfME .tEwkQ :before{box-sizing:inherit}.IOfME .tEwkQ input{box-sizing:border-box}@media only screen and (max-width:640px){[data-query=media] .IOfME .tEwkQ{height:calc(100% - 100px);top:100px}[dir] [data-query=media] .IOfME .tEwkQ{padding:20px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .IOfME .tEwkQ{height:calc(100% - 100px);top:100px}[dir] [data-query=container] .IOfME .tEwkQ{padding:20px}}}@container (width < 640px){[data-query=container] .IOfME .tEwkQ{height:calc(100% - 100px);top:100px}[dir] [data-query=container] .IOfME .tEwkQ{padding:20px}}._6mOxI{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] ._6mOxI{background-color:#fff}@media only screen and (max-width:640px){[data-query=media] ._6mOxI{max-width:100%;top:50px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._6mOxI{max-width:100%;top:50px}}}@container (width < 640px){[data-query=container] ._6mOxI{max-width:100%;top:50px}}";
var styles = {"button_inputModal_container":"_-9vKF","button_inputModal_container_newUi":"IOfME","button_inputModal_container_mobile":"XJIkY","button_inputModal_design_component_container":"YPc9L","button_inputModal_focus_manager":"TQyGq","button_inputModal_separator":"a815v","button_inputModal_scroll":"_9I9aQ","button_inputModal_header":"eN1Ab","button_inputModal_header_text":"GEgGZ","button_inputModal_design_header_text":"P9GAX","header_icon":"pTsC5","errorMessage":"N5LCr","button_inputModal_errorIcon":"zBKRb","tabs_headers_option":"am-QZ","scroll_container":"XNVN5","button_inputModal_tabLabel":"JfTde","button_inputModal_scrollbar_thumb":"yT6j2","scrollbar_thumb":"wiJHZ","button_inputModal_customize_scrollbar_container":"_4-F-t","button_tab_section":"tEwkQ","button_tabs_headers":"_6mOxI"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a, _b;
class ButtonInputModal extends Component {
  constructor(props) {
    var _a2;
    super(props);
    __publicField(this, "useNewSettingsUi", !!((_b = (_a = this.props.experiments) == null ? void 0 : _a.newSettingsModals) == null ? void 0 : _b.enabled));
    __publicField(this, "onSettingsChanged", (settings) => {
      if (this.modalsWithEditorCommands) {
        this.updateComponentData(__spreadValues(__spreadValues({}, this.props.componentData), settings));
      } else if (!isEqual(settings, this.state.settings)) {
        const { design } = this.state;
        const {
          componentData: { button }
        } = this.props;
        this.updateComponentData({ button: __spreadProps(__spreadValues({}, button), { settings, design }) });
        this.setState({ settings });
      }
    });
    __publicField(this, "updateComponentData", (data) => this.modalsWithEditorCommands ? this.props.updateData(data) : this.props.pubsub.update("componentData", data));
    __publicField(this, "onDesignChanged", (design) => {
      const { settings } = this.state;
      if (this.state.activeTab !== designTabValue) {
        this.setState({ activeTab: designTabValue });
      }
      if (!isEqual(design, this.state.design)) {
        const { componentData } = this.props;
        const data = this.modalsWithEditorCommands ? __spreadProps(__spreadValues({}, componentData), { styles: design }) : { button: __spreadProps(__spreadValues({}, componentData.button), { design, settings }) };
        this.updateComponentData(data);
        this.setState({ design });
      }
    });
    __publicField(this, "triggerLinkBi", () => {
      var _a2, _b2, _c, _d, _e, _f;
      const { settings } = this.state;
      const { rel, target, url } = settings;
      const params = this.modalsWithEditorCommands ? {
        link: (_a2 = settings.link) == null ? void 0 : _a2.url,
        newTab: ((_b2 = settings.link) == null ? void 0 : _b2.target) === "BLANK",
        category: WEB_ADDRESS_CATEGORY,
        rel: ((_d = (_c = settings.link) == null ? void 0 : _c.rel) == null ? void 0 : _d.nofollow) && "nofollow"
      } : {
        link: url,
        newTab: isNewTab(target),
        category: WEB_ADDRESS_CATEGORY,
        rel
      };
      (_f = (_e = this.props.helpers) == null ? void 0 : _e.onPluginAction) == null ? void 0 : _f.call(_e, ADD_PLUGIN_LINK_BI, {
        plugin_id: LINK_BUTTON_TYPE,
        params
      });
    });
    __publicField(this, "onConfirm", () => {
      const {
        helpers: { closeModal },
        onSave
      } = this.props;
      const { initialComponentData, design } = this.state;
      if (this.modalsWithEditorCommands && isEmpty(initialComponentData.styles.colors) && this.currentColorEqualToConfig()) {
        this.removeColorsFromComponentData(design);
      } else if (!this.modalsWithEditorCommands && !initialComponentData.design.color && this.currentColorEqualToConfig()) {
        this.removeColorsFromComponentData(design);
      }
      !this.modalsWithEditorCommands && this.setState({ submitted: true, isOpen: false });
      this.triggerLinkBi();
      this.modalsWithEditorCommands ? onSave() : closeModal();
    });
    __publicField(this, "currentColorEqualToConfig", () => {
      var _a2, _b2, _c;
      const { design } = this.state;
      const {
        settings: { colors }
      } = this.props;
      const textColor = this.modalsWithEditorCommands ? (_a2 = design.colors) == null ? void 0 : _a2.text : design.color;
      const borderColor = this.modalsWithEditorCommands ? (_b2 = design.colors) == null ? void 0 : _b2.border : design.borderColor;
      const background = this.modalsWithEditorCommands ? (_c = design.colors) == null ? void 0 : _c.background : design.background;
      return (textColor === (colors == null ? void 0 : colors.color1) || textColor === "#FEFDFD") && (borderColor === (colors == null ? void 0 : colors.color8) || borderColor === "#0261FF") && (background === (colors == null ? void 0 : colors.color8) || background === "#0261FF");
    });
    __publicField(this, "handleKeyPress", (e) => {
      if (e.charCode === KEYS_CHARCODE.ENTER) {
        this.modalsWithEditorCommands ? this.props.onSave() : this.onConfirm();
      }
      if (e.charCode === KEYS_CHARCODE.ESCAPE) {
        this.onCancel();
      }
    });
    __publicField(this, "onCancel", () => this.modalsWithEditorCommands ? this.props.onCancel() : this.onCloseRequested());
    __publicField(this, "onCloseRequested", () => {
      const {
        componentData,
        pubsub,
        onCloseRequested,
        helpers: { closeModal }
      } = this.props;
      const { initialComponentData } = this.state;
      if (this.modalsWithEditorCommands && isEmpty(initialComponentData.styles.colors)) {
        this.removeColorsFromComponentData(initialComponentData.styles);
      } else if (!this.modalsWithEditorCommands && !initialComponentData.design.color) {
        this.removeColorsFromComponentData(initialComponentData.design);
      }
      if (onCloseRequested) {
        onCloseRequested(__spreadProps(__spreadValues({}, componentData), { button: initialComponentData }));
      } else {
        pubsub.update("componentData", { button: initialComponentData });
      }
      this.setState({ isOpen: false });
      closeModal();
    });
    __publicField(this, "removeColorsFromComponentData", (design) => {
      const { pubsub, componentData } = this.props;
      const designToSave = {
        borderWidth: design.borderWidth,
        padding: design.padding,
        borderRadius: design.borderRadius
      };
      if (this.modalsWithEditorCommands) {
        this.updateComponentData(__spreadProps(__spreadValues({}, componentData), { styles: { colors: {}, border: design.border } }));
      } else {
        const componentDataToSave = pubsub.get("componentData");
        componentDataToSave.button.design = designToSave;
        this.updateComponentData(componentDataToSave);
      }
    });
    __publicField(this, "handleOnMouseEnterDesign", () => {
      this.setState({ isHover: true, activeTab: designTabValue });
    });
    __publicField(this, "handleOnMouseLeaveDesign", () => {
      this.setState({ isHover: false });
    });
    __publicField(this, "handleOnMouseEnterSettings", () => {
      this.setState({ activeTab: settingsTabValue });
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
    const { componentData, experiments = {} } = this.props;
    this.modalsWithEditorCommands = (_a2 = experiments.tiptapEditor) == null ? void 0 : _a2.enabled;
    this.state = {
      settings: this.modalsWithEditorCommands ? componentData : __spreadValues({}, componentData.button.settings),
      design: this.modalsWithEditorCommands ? componentData.styles : __spreadValues({}, componentData.button.design),
      initialComponentData: this.modalsWithEditorCommands ? componentData : __spreadValues({}, componentData.button),
      isHover: false,
      activeTab: settingsTabValue,
      showLinkPanel: this.modalsWithEditorCommands ? componentData.type === "LINK" : !this.props.settings.isActionButton
    };
    this.setScrollbarRef = (element) => {
      this.scrollbarRef = element;
    };
  }
  render() {
    const { theme, t, uiSettings, onCancel, isMobile } = this.props;
    const { showLinkPanel } = this.state;
    const { styles: styles2 } = this;
    const settingTabLabel = /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_settingTab }, /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_tabTitle }, /* @__PURE__ */ React.createElement("p", { className: styles2.button_inputModal_tabLabel }, t("ButtonModal_Settings_Tab"))));
    const designTabLabel = /* @__PURE__ */ React.createElement("p", { className: styles2.button_inputModal_tabLabel }, t("ButtonModal_Design_Tab"));
    const settingsComponent = /* @__PURE__ */ React.createElement(
      SettingsComponent,
      __spreadProps(__spreadValues({
        t,
        theme,
        uiSettings
      }, this.props), {
        onSettingsChange: this.onSettingsChanged.bind(this),
        settingsObj: this.state.settings,
        onKeyPress: this.handleKeyPress,
        showLinkPanel
      })
    );
    const designComponent = /* @__PURE__ */ React.createElement(
      DesignComponent,
      __spreadProps(__spreadValues({}, this.props), {
        theme,
        t,
        styles: styles2,
        onDesignChange: this.onDesignChanged.bind(this),
        designObj: this.state.design,
        onKeyPress: this.handleKeyPress
      })
    );
    let mobileView = null;
    if (isMobile) {
      mobileView = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        SettingsMobileHeader,
        {
          onSave: this.onConfirm,
          onCancel: this.onCancel,
          theme: styles2,
          title: this.useNewSettingsUi && t("ButtonModal_Header"),
          t
        }
      ), /* @__PURE__ */ React.createElement(PreviewComponent, __spreadValues({ buttonObj: this.state }, this.props)), /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_scroll, ref: this.setScrollbarRef }, /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_container, "data-hook": "ButtonInputModal" }, /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_header_text }, t("ButtonModal_Settings_Tab")), settingsComponent), /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_separator }), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles2.button_inputModal_design_component_container,
          "data-hook": "ButtonInputModal"
        },
        /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_design_header_text }, t("ButtonModal_Design_Tab")),
        designComponent
      )));
    }
    return /* @__PURE__ */ React.createElement("div", null, isMobile && !this.useNewSettingsUi ? mobileView : /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles2.button_inputModal_container, {
          [styles2.button_inputModal_container_newUi]: this.useNewSettingsUi
        }),
        "data-hook": "ButtonInputModal"
      },
      isMobile && this.useNewSettingsUi && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        SettingsMobileHeader,
        {
          onSave: this.onConfirm,
          onCancel: this.modalsWithEditorCommands ? onCancel : this.onCloseRequested,
          theme: styles2,
          title: this.useNewSettingsUi && t("ButtonModal_Header"),
          t,
          useNewSettingsUi: this.useNewSettingsUi
        }
      )),
      /* @__PURE__ */ React.createElement("div", null, this.useNewSettingsUi && !isMobile ? /* @__PURE__ */ React.createElement(
        SettingsPanelHeader,
        {
          title: t("ButtonModal_Header"),
          onClose: this.onCloseRequested
        }
      ) : !isMobile && /* @__PURE__ */ React.createElement(
        "div",
        {
          role: "heading",
          "aria-level": 2,
          "aria-labelledby": "button_modal_hdr",
          className: styles2.button_inputModal_header
        },
        /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_header_text }, t("ButtonModal_Header"))
      ), /* @__PURE__ */ React.createElement(FocusManager, null, /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_focus_manager }, /* @__PURE__ */ React.createElement(
        Tabs,
        {
          value: this.state.activeTab,
          theme: this.styles,
          headersStyle: this.useNewSettingsUi && styles2.button_tabs_headers
        },
        /* @__PURE__ */ React.createElement(Tab, { label: settingTabLabel, value: settingsTabValue, theme: this.styles }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: classNames(styles2.button_tab_section, {
              [styles2.button_tab_section_newUi]: this.useNewSettingsUi
            }),
            role: "button",
            tabIndex: "0",
            onMouseEnter: this.handleOnMouseEnterSettings
          },
          settingsComponent
        )),
        /* @__PURE__ */ React.createElement(Tab, { label: designTabLabel, value: designTabValue, theme: this.styles }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: classNames(styles2.button_tab_section, {
              [styles2.button_tab_section_newUi]: this.useNewSettingsUi
            })
          },
          /* @__PURE__ */ React.createElement(
            Scrollbars,
            {
              ref: this.setScrollbarRef,
              renderThumbVertical: () => this.state.isHover ? /* @__PURE__ */ React.createElement("div", { className: styles2.button_inputModal_scrollbar_thumb }) : /* @__PURE__ */ React.createElement("div", null),
              className: styles2.button_inputModal_customize_scrollbar_container,
              onMouseEnter: this.handleOnMouseEnterDesign,
              onMouseLeave: this.handleOnMouseLeaveDesign
            },
            designComponent
          )
        ))
      )))),
      !isMobile && /* @__PURE__ */ React.createElement(
        SettingsPanelFooter,
        {
          fixed: true,
          save: this.onConfirm,
          cancel: this.onCancel,
          theme: styles2,
          t,
          buttonSize: BUTTON_SIZE.small
        }
      )
    ));
  }
}
ButtonInputModal.propTypes = {
  componentData: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  settings: PropTypes.object.isRequired,
  uiSettings: PropTypes.object,
  helpers: PropTypes.object,
  experiments: PropTypes.object,
  isMobile: PropTypes.bool,
  updateData: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  pubsub: PropTypes.object,
  onCloseRequested: PropTypes.func,
  languageDir: PropTypes.string
};

export { ButtonInputModal as default };
//# sourceMappingURL=buttonInputModal.js.map
